import app from "../_app";

const SELECTOR = {
  OVERLAY: ".site-overlay",
  PASSWORD_FORM: ".site-overlay__password-form",
  PASSWORD_INPUT: ".site-overlay__password-input",
  PASSWORD_ERROR: ".site-overlay__password-error",
};

const STORAGE_KEY = "site_overlay_dismissed";

const initSiteOverlay = () => {
  const overlay = document.querySelector(SELECTOR.OVERLAY);
  if (!overlay) return;

  const excludeSources = overlay.dataset.excludeSources || "";
  const excludeKeys = excludeSources.split("\n").map(s => s.trim()).filter(Boolean);
  const urlParams = new URLSearchParams(window.location.search);
  
  if (excludeKeys.some(key => urlParams.has(key))) {
    return;
  }

  // Check if overlay was already dismissed
  const isDismissed = sessionStorage.getItem(STORAGE_KEY) === "true";
  if (isDismissed) {
    overlay.remove();
    return;
  }

  overlay.classList.remove("site-overlay--hidden");

  // Lock body scroll when overlay is present
  app.lockBody();

  const passwordForm = overlay.querySelector(SELECTOR.PASSWORD_FORM);
  if (!passwordForm) return;

  const passwordInput = overlay.querySelector(SELECTOR.PASSWORD_INPUT);
  const passwordError = overlay.querySelector(SELECTOR.PASSWORD_ERROR);
  const correctPassword = passwordForm.dataset.password || "";

  // Focus the password input when overlay is shown
  if (passwordInput) {
    requestAnimationFrame(() => {
      passwordInput.focus();
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const enteredPassword = passwordInput.value.trim();

    if (enteredPassword.toLowerCase() === correctPassword.toLowerCase()) {
      // Correct password - dismiss overlay and unlock body
      sessionStorage.setItem(STORAGE_KEY, "true");
      app.unlockBody();
      overlay.remove();
    } else {
      // Incorrect password - show error
      if (passwordError) {
        passwordError.classList.remove("hidden");
      }
      passwordInput.value = "";
      passwordInput.focus();
    }
  };

  passwordForm.addEventListener("submit", handleSubmit);
};

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSiteOverlay);
} else {
  initSiteOverlay();
}
